import { render, staticRenderFns } from "./SohAnalysis.vue?vue&type=template&id=568bb1ba"
import script from "./SohAnalysis.vue?vue&type=script&lang=js"
export * from "./SohAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SohAnalysis.vue?vue&type=style&index=0&id=568bb1ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports